import { MARQUEE_ITEMS } from "@/data/content";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-gold/20 bg-noir py-5" aria-hidden="true" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center gap-12 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-12">
            <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-cream/70">{item}</span>
            <span className={`h-1.5 w-1.5 rotate-45 ${i % 2 === 0 ? "bg-gold" : "bg-leaf-light"}`} />
          </span>
        ))}
      </div>
    </div>
  );
};
